import { ErrorMessage, Form, Formik } from "formik";
import React, { useState } from "react";
import MyTextInput from "../../app/common/form/MyTextInput";
import { Button, Header, Label, Modal, Divider, Grid, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import { ForgotPasswordForm } from "./ForgotPasswordForm";
import { useTranslation } from 'react-i18next';
import RegisterForm from './RegisterForm';

export default observer(function LoginForm() {
    const { t } = useTranslation();
    const { userStore, modalStore } = useStore();
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [socialLoading, setSocialLoading] = useState<string | null>(null);


    const handleCloseForgotPassword = () => {
        setShowForgotPassword(false);
    };

    const handleSocialLogin = async (provider: 'google' | 'facebook') => {
        try {
            setSocialLoading(provider);
            await userStore.socialLogin(provider);
        } catch (error) {
            console.error(`${provider} login failed:`, error);
        } finally {
            setSocialLoading(null);
        }
    };

    return (
        <>
            <Formik
                initialValues={{ email: '', password: '', error: null }}
                onSubmit={(values, { setErrors }) =>
                    userStore.login(values).catch(error =>
                        setErrors({ error: t('loginForm.invalidCredentials') })
                    )
                }
            >
                {({ handleSubmit, isSubmitting, errors }) => (
                    <Form className="ui form" onSubmit={handleSubmit} autoComplete="off">
                        <Header as='h2' content={t('loginForm.title')} color="teal" textAlign="center" />

                        {/* Social Login Buttons */}
                        <div style={{ marginBottom: '20px' }}>
                            <Grid columns={1} stackable>
                                <Grid.Column>
                                    <Button
                                        type="button"
                                        fluid
                                        color="google plus"
                                        loading={socialLoading === 'google'}
                                        disabled={socialLoading !== null || isSubmitting}
                                        onClick={() => handleSocialLogin('google')}
                                    >
                                        <Icon name="google" />
                                        {t('loginForm.socialLogin.google')}
                                    </Button>
                                </Grid.Column>
                                {/*
                                <Grid.Column>
                                    <Button
                                        type="button"
                                        fluid
                                        color="facebook"
                                        loading={socialLoading === 'facebook'}
                                        disabled={socialLoading !== null || isSubmitting}
                                        onClick={() => handleSocialLogin('facebook')}
                                    >
                                        <Icon name="facebook" />
                                        {t('loginForm.socialLogin.facebook')}
                                    </Button>
                                </Grid.Column>
                                 */}
                            </Grid>
                        </div>

                        <Divider horizontal>{t('loginForm.divider')}</Divider>

                        <MyTextInput name="email" placeholder={t('loginForm.emailPlaceholder')} />
                        <MyTextInput name="password" placeholder={t('loginForm.passwordPlaceholder')} type="password" />
                        <ErrorMessage
                            name='error'
                            render={() =>
                                <Label style={{ marginBottom: 10 }} basic color='red' content={errors.error} />
                            }
                        />

                        <Button
                            loading={isSubmitting}
                            primary
                            content={t('loginForm.loginButton')}
                            type="submit"
                            fluid
                            disabled={socialLoading !== null}
                        />

                        <div style={{ textAlign: 'center', marginTop: '15px' }}>
                            <Button
                                type="button"
                                basic
                                color="blue"
                                content={t('loginForm.forgotPasswordButton')}
                                onClick={() => setShowForgotPassword(true)}
                                style={{ background: 'none', padding: '5px' }}
                                disabled={socialLoading !== null || isSubmitting}
                            />
                        </div>

                        <div style={{ textAlign: 'center', marginTop: '8px' }}>
                            <Button
                                type="button"
                                basic
                                color="teal"
                                content={t('homePage.registerButton')}
                                onClick={() => modalStore.openModal(<RegisterForm />)}
                                style={{ background: 'none', padding: '5px' }}
                                disabled={socialLoading !== null || isSubmitting}
                            />
                        </div>
                    </Form>
                )}
            </Formik>

            <Modal
                open={showForgotPassword}
                onClose={handleCloseForgotPassword}
                size="small"
                closeIcon
            >
                <Modal.Content>
                    <ForgotPasswordForm onClose={handleCloseForgotPassword} />
                </Modal.Content>
            </Modal>
        </>
    );
});